import { render, staticRenderFns } from "./AddTaxModal.vue?vue&type=template&id=3d029ce6&"
import script from "./AddTaxModal.vue?vue&type=script&lang=js&"
export * from "./AddTaxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports